import InitialState from './AssessmentTypeListInitialState'

import { ACTION_TYPES } from 'lib/Constants'

const {
    LOGOUT_SUCCESS,
    CLEAR_ALL_AUTH_DATA,

    CLEAR_ASSESSMENT_TYPE_LIST,
    CLEAR_ASSESSMENT_TYPE_LIST_ERROR,
    LOAD_ASSESSMENT_TYPE_LIST_REQUEST,
    LOAD_ASSESSMENT_TYPE_LIST_SUCCESS,
    LOAD_ASSESSMENT_TYPE_LIST_FAILURE
} = ACTION_TYPES

const initialState = new InitialState()

export default function careLevelListReducer (state = initialState, action) {
    if (!(state instanceof InitialState)) {
        return initialState.mergeDeep(state)
    }

    switch (action.type) {
        case LOGOUT_SUCCESS:
        case CLEAR_ALL_AUTH_DATA:
        case CLEAR_ASSESSMENT_TYPE_LIST:
            return state
                .removeIn(['error'])
                .setIn(['isFetching'], false)
                .setIn(['shouldReload'], false)
                .setIn(['dataSource', 'data'], [])

        case CLEAR_ASSESSMENT_TYPE_LIST_ERROR:
            return state
                .removeIn(['error'])

        case LOAD_ASSESSMENT_TYPE_LIST_REQUEST: {
            return state
                .removeIn(['error'])
                .setIn(['isFetching'], true)
        }

        case LOAD_ASSESSMENT_TYPE_LIST_SUCCESS: {
            return state
                .setIn(['isFetching'], false)
                .setIn(['shouldReload'], false)
                .setIn(['dataSource', 'data'], action.payload)
        }

        case LOAD_ASSESSMENT_TYPE_LIST_FAILURE:
            return state
                .setIn(['isFetching'], false)
                .setIn(['shouldReload'], false)
                .setIn(['error'], action.payload)
    }

    return state
}
